import { render } from "./AddMenuItem.vue?vue&type=template&id=0bc6d5a1&scoped=true"
import script from "./AddMenuItem.vue?vue&type=script&lang=js"
export * from "./AddMenuItem.vue?vue&type=script&lang=js"

import "./AddMenuItem.vue?vue&type=style&index=0&id=0bc6d5a1&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc6d5a1"]])

export default __exports__